import { render, staticRenderFns } from "./SpineAssessmentReport.vue?vue&type=template&id=fdcfc0fc&scoped=true"
import script from "./SpineAssessmentReport.vue?vue&type=script&lang=js"
export * from "./SpineAssessmentReport.vue?vue&type=script&lang=js"
import style0 from "./SpineAssessmentReport.vue?vue&type=style&index=0&id=fdcfc0fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcfc0fc",
  null
  
)

export default component.exports